import { render, staticRenderFns } from "./THGChangeHistory.vue?vue&type=template&id=5710e3a2&scoped=true"
import script from "./THGChangeHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGChangeHistory.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGChangeHistory.vue?vue&type=style&index=0&id=5710e3a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5710e3a2",
  null
  
)

export default component.exports